import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Modal from '../components/Modal';
import LoadingOverlay from '../components/LoadingOverlay';
import { authApi } from '../services/api';
import logo from '../assets/logo.png';

export default function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [email, setEmail]     = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError]     = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await authApi.forgotPassword({ email });
      setSuccess(true);
    } catch (err: any) {
      setError(err.response?.data?.message || "Errore nell'invio della email.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
      <div style={{ width: '100%', maxWidth: 390, display: 'flex', flexDirection: 'column', gap: 24 }}>

        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 8 }}>
          <img src={logo} alt="Molti Like" style={{ width: 220, height: 'auto', objectFit: 'contain' }} />
        </div>

        <div style={{ textAlign: 'center' }}>
          <p style={{ fontSize: 22, fontWeight: 700, color: 'var(--text-1)', marginBottom: 6, letterSpacing: '-0.02em' }}>Recupera Password</p>
          <p className="sub">Inserisci la tua email e ti invieremo un link per reimpostare la password.</p>
        </div>

        {success && <Modal isOpen title="Email inviata!" message="Controlla la tua casella email: il link per reimpostare la password è valido per 60 minuti." type="success" confirmText="Torna al login" onConfirm={() => navigate('/login')} />}
        {success ? null : (
          <>
            {loading && <LoadingOverlay title="Invio in corso..." subtitle="Ti mandiamo il link via email" icon="mail" />}
            {error && <Modal isOpen title="Invio non riuscito" message={error} type="error" onConfirm={() => setError('')} />}
            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              <div className="form-group">
                <label className="form-label">Email</label>
                <input
                  className="form-input"
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder="mario@esempio.com"
                  autoComplete="email"
                  required
                />
              </div>
              <button type="submit" className="btn btn-primary" disabled={loading} style={{ marginTop: 4 }}>
                Invia link di reset
              </button>
            </form>
          </>
        )}

        <p style={{ textAlign: 'center', fontSize: 13, color: 'var(--text-2)' }}>
          <Link to="/login" style={{ color: 'var(--primary)', fontWeight: 600, textDecoration: 'none' }}>
            ← Torna al login
          </Link>
        </p>
      </div>
    </div>
  );
}
